import {
  Alert,
  AlertPriority,
  AlertSocket,
  AlertStatus,
  AlertToken,
  AppStateMonitorAlerts,
  IAlertMonitor,
  PresentationType,
  Reminder,
  ReminderAction,
  StatusSettings,
  ViewType,
} from ".";
import { DeviceActionType, DEVICES } from "../../redux/devices/types";
import { HEALTH_CHECK } from "../../redux/healthCheck/types";
import {
  DAILY_PLAN,
  IGetResidentsActivitiesSuccess,
  PlanActionType,
} from "../../redux/residentActivityPlan/types";
import { StorageHelper, StorageType } from "../../utils/StorageHelper";
import { Device, DeviceType } from "../devices";
import { ResolveAlert } from "../modalFeedback";
import {
  IBatchDisconectAndChangeResidentsSuccess,
  ResidentActionTypes,
  RESIDENTS,
} from "../residents/types";
import { AlertActionType, ALERTS } from "./types";
const getSettings = () => {
  const val = StorageHelper.instance.GetItem(StorageType.VIEW_AND_PRESENTATION);
  return val
    ? JSON.parse(val)
    : { view: ViewType.Notification, presentation: PresentationType.Cards };
};
const initialState: AppStateMonitorAlerts = {
  alerts: {},
  devicesAlerts: {},
  isLoading: undefined,
  reminders: {},
  settings: getSettings(),
};

export const alert = (
  state = initialState,
  action:
    | AlertActionType
    | ResidentActionTypes
    | PlanActionType
    | DeviceActionType
): AppStateMonitorAlerts => {
  switch (action.type) {
    case HEALTH_CHECK.NEED_TO_NOTIFY_LOGIN: {
      return initialState;
    }
    case ALERTS.HANDLE_REQUEST:
    case ALERTS.GET_ALERTS_FROM_RESIDENT_REQUEST:
      return { ...state, isLoading: true };

    case RESIDENTS.GET_RESIDENTS_RULES_ALERTS_STATUSES_SUCCESS: {
      const items = action.payload;

      const mapped = {};

      if (Array.isArray(items) && items.length > 0) {
        items?.map((el: any) => {
          const { node, alerts, devices, self } = el;
          const device = devices.find(
            (el) => el.type === DeviceType.vitals
          ) as Device;
          const _alerts: IAlertMonitor[] = [];

          _alerts.push(
            ...alerts
              .filter((alert: Alert) => {
                return (
                  [
                    AlertStatus.done.toString(),
                    AlertStatus.canceled.toString(),
                    AlertStatus.AutomaticallyDone.toString(),
                    AlertStatus.ManualDone.toString(),
                  ].indexOf(alert.status.toString()) === -1
                );
              })
              .map((alert: any) => {
                return {
                  ...alert,
                  alertToken: alert.self.id,
                  patientId: self.id,
                  date: alert.generated,
                  lastUpdate: alert.generated,
                  room: device?.room || "",
                  bed: device?.bed || "",
                  nodeId: node ? Number.parseInt(node.id) : "",
                  patientName: [el.firstName, el.lastName].join(" "),
                };
              })
          );

          mapped[el.self.id] = _alerts;
          return null;
        });

        return { ...state, alerts: mapped, isLoading: false };
      }
      return { ...state, isLoading: false };
    }

    case ALERTS.GET_NEW_ALERT_BY_SOCKET: {
      const data = action.payload as AlertSocket;
      const residentAlerts = state.alerts[data.patientId]
        ? state.alerts[data.patientId].concat()
        : [];
      const alertIndex = residentAlerts?.findIndex(
        (alert) =>
          alert.alertToken === data.alertToken &&
          alert.patientId === data.patientId
      );

      if (alertIndex !== -1) {
        const newAlert: IAlertMonitor = {
          ...data,

          priority: data.priority,
          generated: data.time,
          lastUpdate: data.lastUpdate, //selectedUpdate,
          status: AlertStatus.updated,
        };
        residentAlerts.splice(alertIndex, 1, newAlert);
        return {
          ...state,
          alerts: { ...state.alerts, [data.patientId]: residentAlerts },
        };
      }

      const newAlert: IAlertMonitor = {
        ...data,
        deviceId: undefined,
        nodeId: data.nodeId,
        status: AlertStatus.open,
      };
      residentAlerts.push(newAlert);
      return {
        ...state,
        alerts: { ...state.alerts, [data.patientId]: residentAlerts },
      };
    }

    case ALERTS.SET_ALERTS_BY_ALERT_TYPE_AND_RESIDENT_ID_SUCSSESS:
      const data = action.payload as ResolveAlert;
      const residentAlerts = state.alerts[data.patientId]
        ? state.alerts[data.patientId]
        : [];
      const alertsFiltred = residentAlerts.filter((alert: IAlertMonitor) => {
        if (alert.patientId === data.patientId)
          return alert.alertToken !== data.alertId;
        return true;
      });
      return {
        ...state,
        alerts: { ...state.alerts, [data.patientId]: alertsFiltred },
        isLoading: false,
      };

    case ALERTS.HANDLE_SUCCESS:
      return { ...state, isLoading: false };

    case RESIDENTS.DELETE_RESIDENT_BY_SOCKET: {
      const data = action.payload;
      const alertsCopy = { ...state.alerts };
      delete alertsCopy[data.id];
      return { ...state, alerts: alertsCopy };
    }
    case RESIDENTS.BATCH_DISCONNECT_AND_CHANGE_SUCCESS: {
      const data = (
        action as unknown as IBatchDisconectAndChangeResidentsSuccess
      ).payload;

      const ids = data.map((el) => el.id);
      const alertsCopy = { ...state.alerts };
      ids.map((residentId: string) => (alertsCopy[residentId] = []));

      return { ...state, alerts: alertsCopy };
    }
    case ALERTS.HANDLE_FAILURE:
    case ALERTS.GET_ALERTS_FROM_RESIDENT_FAILURE:
      return { ...state, isLoading: false };

    case ALERTS.SET_MONITOR_ALERTS_SETTINGS: {
      const settings = action.payload as StatusSettings;
      StorageHelper.instance.SaveItem(
        StorageType.VIEW_AND_PRESENTATION,
        settings
      );
      return { ...state, settings: { ...state.settings, ...settings } };
    }
    case ALERTS.GET_NEW_REMINDER_BY_SOCKET: {
      const data = action.payload as Reminder;
      const residentReminders = state.reminders[data?.residentId]
        ? state.reminders[data?.residentId].concat()
        : [];
      residentReminders.push({ ...data, lastUpdate: data.lastUpdate });
      return {
        ...state,
        reminders: {
          ...state.reminders,
          [data?.residentId]: residentReminders,
        },
      };
    }
    case ALERTS.GET_REMINDER_HANDLED_BY_SOCKET:
    case ALERTS.GET_REMINDER_MISSED_BY_SOCKET: {
      const data = action.payload as ReminderAction;
      const residentReminders = state.reminders[data?.residentId]
        ? state.reminders[data?.residentId].concat()
        : [];
      const index = residentReminders.findIndex(
        (el) =>
          el.activityType === data.activityType &&
          el.lastUpdate === data.activityTime
      );
      if (index !== -1) {
        residentReminders.splice(index, 1);
        return {
          ...state,
          reminders: {
            ...state.reminders,
            [data?.residentId]: residentReminders,
          },
        };
      }
      return state;
    }
    case DAILY_PLAN.GET_RESIDENTS_ACTIVITIES_SUCCESS: {
      const { data } = (action as IGetResidentsActivitiesSuccess).payload;
      const reminders = data;
      const remindersMapped = {};
      reminders.map((el) => {
        if (el?.status?.toLowerCase() !== "Open".toLowerCase()) return null;
        const rem: Reminder = {
          activityType: el.type,
          lastUpdate: el.date,
          residentId: el?.residentId,
          nodeId: 0,
          activityParams: el?.activityParams,
          dailyScheduleId: el?.dailyScheduleId,
          bed: el?.bed || "",
          room: el?.room || "",
          utcDate: el?.utcDate,
        };
        const rems = remindersMapped[el?.residentId] || [];
        remindersMapped[el?.residentId] = rems.concat(rem);
        return null;
      });
      return { ...state, reminders: remindersMapped };
    }

    case DEVICES.GET_USER_NEARBY_SUCCESS: {
      const items = action.payload;
      const devicesAlerts = {};
      Object.keys(items).map((deviceId) => {
        const oneDevice = items[deviceId];
        let data;
        if (oneDevice?.nearBed || oneDevice.nearBed) {
          const nearRoom = oneDevice?.nearRoom || [];
          const nearBed = [];
          data = nearBed.concat(nearRoom);
        } else data = items[deviceId];
        data = data?.filter((el) => el?.id && el?.alert);
        if (data.length > 0) {
          devicesAlerts[deviceId] = data.map((el) => {
            return {
              alertToken: AlertToken.UserNearby,
              patientId: undefined,
              date: el?.datetime,
              lastUpdate: el?.datetime,
              room: "",
              bed: "",
              nodeId: 0,
              patientName: undefined,
              priority: AlertPriority.med,
              status: AlertStatus.open,
              user: {
                firstName: "",
                lastName: "",
                id: el?.id,
                picture: undefined,
              },
            };
          });
        }
        return null;
      });

      return { ...state, devicesAlerts };
    }
    case ALERTS.GET_USER_NEARBY_BY_SOCKET: {
      const { data, deviceId, room, bed } = action.payload;
      const filter = data?.filter((el) => el?.id && el?.alert);
      const newDeviceAlerts = { ...state.devicesAlerts };
      newDeviceAlerts[deviceId] = filter.map((el) => {
        return {
          alertToken: AlertToken.UserNearby,
          patientId: undefined,
          date: el?.datetime,
          lastUpdate: el?.datetime,
          room: room,
          bed: bed,
          nodeId: 0,
          patientName: undefined,
          priority: AlertPriority.med,
          status: AlertStatus.open,
          user: {
            firstName: "",
            lastName: "",
            id: el?.id,
            picture: undefined,
          },
        };
      });
      return { ...state, devicesAlerts: newDeviceAlerts };
    }
    default:
      return state;
  }
};

export default alert;
